import { FC } from 'react';
import V2Form from '@/common/components/Form/V2Form';
import V2FormCheckbox from '@/common/components/Form/V2FormCheckbox/V2FormCheckbox';

export const competitionTypeOptions = [
  { value: 1, label: '竞争' },
  { value: 2, label: '协同' },
  { value: 3, label: '一般' },
];

const CompetitionTypeFilter: FC<{
  visible: boolean;
  value: number[];
  onChange: (value: number[]) => void;
}> = ({ visible, value, onChange }) => {
  if (!visible) return null;
  return (
    <V2Form layout='inline'>
      <V2FormCheckbox
        label='竞争关系'
        name='competitionTypes'
        options={competitionTypeOptions}
        config={{ value, onChange: (checkedValue) => onChange(checkedValue.map(Number)) }}
      />
    </V2Form>
  );
};

export default CompetitionTypeFilter;
